import { isToolUIPart, type UIMessage } from "ai";

/** App-side workaround for ai@7.0.15 dropping signatures on approval response. */
export class ToolApprovalSignatures {
  private signatures = new Map<string, string>();

  capture(messages: UIMessage[]) {
    for (const message of messages) {
      for (const part of message.parts) {
        if (isToolUIPart(part) && part.approval?.signature) {
          this.signatures.set(
            JSON.stringify([message.id, part.toolCallId, part.approval.id]),
            part.approval.signature,
          );
        }
      }
    }
  }

  restore<T extends UIMessage>(messages: T[]): T[] {
    return messages.map((message) => ({
      ...message,
      parts: message.parts.map((part) => {
        if (!isToolUIPart(part) || !part.approval || part.approval.signature) return part;
        const signature = this.signatures.get(
          JSON.stringify([message.id, part.toolCallId, part.approval.id]),
        );
        return signature
          ? { ...part, approval: { ...part.approval, signature } }
          : part;
      }),
    }));
  }
}
